module.exports = __webpack_public_path__ + "img/dk.38514c9d.jpg";